module.exports = __webpack_public_path__ + "media/fonts/ABC_Weise_Bold_201014-04618663bf5cfabaacd14399451c273c.ttf";